import {
  SHOW_POPUP_LOGIN_MINI,
  SHOW_POPUP_EARNMORE,
  SHOW_POPUP_PIECE,
  SHOW_POPUP_CHANGE_COINS_SUCCESS,
  SHOW_POPUP_GIVE_PIECE,
  MINIGAME_CONFIG,
  MINIGAME_TAKE_PRIZE,
  MINIGAME_PRIZE_COLLECTION,
  MINIGAME_CHANGE_ATTEMP_BY_ID,
  MINIGAME_MISSIONS,
  MINIGAME_PIECE_COLLECTED,
  MINIGAME_AWARD_LIST,
  MINIGAME_CURRENT_CYCLE_LIST_WINNER,
  MINIGAME_SPIN_HISTORY,
  MINIGAME_ADD_PIECE_LINK,
  MINIGAME_CONFIRM_PIECE_LINK,
  MINIGAME_GET_SPIN_AWARD,
  MINIGAME_GET_SPIN_USER,
  MINIGAME_HISTORY,
  MINI_SET_SPIN,
  MINIGAME_OPEN_POPUP_ERROR,
  SHOW_POPUP_GIVE_PIECE_SUCCESS,
  SHOW_POPUP_MISSION,
  MINIGAME_PAST_CYCLE_LIST_WINNER,
  MINIGAME_RANKING,
  SHOW_POPUP_PUZZLE,
  SHOW_POPUP_INTRO_GIFT,
  MINIGAME_GET_RULE,
} from "./contants";

const initState = {
  // data api
  configMiniGame: {},
  dataSpinAwardMini: {},
  dataSpinUserMini: {},
  dataPrizeCollectionMini: [],
  dataAwardListMini: [],
  dataMissionMini: {},
  dataChangeAttempByIdMini: {},
  dataTakePrizeMini: {},
  dataListWinnerMini: [],
  dataListWinnerPastMini: [],
  dataSpinHistoryMini: {},
  dataAddPieceLinkMini: {},
  dataConfirmPieceLink: {},
  dataPieceCollectedMini: {},
  dataHistoryMini: [],
  dataPopupErrorMini: {},
  dataRankingMini: [],
  dataRule: [],

  // Popup
  isShowPopupLogin: false,
  popupIntroGift: {
    isShow: false,
    isSetCookie: false,
  },
  popupEarnMore: {
      isShowPopup: false,
      step: null
    },
  popupChangeCoinsSuccess: {
    isShowPopupChangeCoinsSuccess: false,
    totalCoins: 0,
  },
  popupPiece: {
    isShowPopupPiece: false,
    type: null,
    turn: 0,
    data: {}
  },
  popupGivePiece: {
    isShow: false,
    type: null,
    link: "",
    data: null
  },

  popupGivePieceSuccess: {
    isShow: false,
    type: null,
    data: null,
  },

  popupMission: {
    isShow: false,
    type: null,
    coin: 0,
    superCoin:0,
    missionName: null,
  },

  popupPuzzle: {
    isShow: false,
    data: null,
  }
};

const reducerMiniGame = (state = initState, actions) => {
  switch (actions.type) {
    case SHOW_POPUP_INTRO_GIFT:
      return {
        ...state,
        popupIntroGift: actions.data,
      }
     case SHOW_POPUP_LOGIN_MINI:
      return {
        ...state,
        isShowPopupLogin: actions.data,
      };
    case MINIGAME_OPEN_POPUP_ERROR:
      return {
        ...state,
        dataPopupErrorMini: actions.data,
      };
    case MINI_SET_SPIN:
      return {
        ...state,
        dataSpinUserMini: actions.data,
      };
    case MINIGAME_HISTORY:
      return {
        ...state,
        dataHistoryMini: actions.payload.data,
      };
    case MINIGAME_CURRENT_CYCLE_LIST_WINNER:
      return {
        ...state,
        dataListWinnerMini: actions.payload.data,
      };
    case MINIGAME_PAST_CYCLE_LIST_WINNER:
      return {
        ...state,
        dataListWinnerPastMini: actions.payload.data,
      };
    case MINIGAME_GET_SPIN_AWARD:
      return {
        ...state,
        dataSpinAwardMini: actions.payload.data,
      };
    case MINIGAME_GET_SPIN_USER:
      return {
        ...state,
        dataSpinUserMini: actions.payload.data,
      };
    case MINIGAME_SPIN_HISTORY:
      return {
        ...state,
        dataSpinHistoryMini: actions.payload.data,
      };
    case MINIGAME_ADD_PIECE_LINK:
      return {
        ...state,
        dataAddPieceLinkMini: actions.payload.data,
      };
    case MINIGAME_CONFIRM_PIECE_LINK:
      return {
        ...state,
        dataConfirmPieceLink: actions.payload.data,
      };

    case MINIGAME_CONFIG:
      return {
        ...state,
        configMiniGame: actions.payload.data,
      };
    case MINIGAME_AWARD_LIST:
      return {
        ...state,
        dataAwardListMini: actions.payload.data,
      };
    case MINIGAME_PIECE_COLLECTED:
      return {
        ...state,
        dataPieceCollectedMini: actions.payload.data,
      };
    case MINIGAME_MISSIONS:
      return {
        ...state,
        dataMissionMini: actions.payload.data,
      };
    case MINIGAME_CHANGE_ATTEMP_BY_ID:
      return {
        ...state,
        dataChangeAttempByIdMini: actions.payload.data,
      };
    case MINIGAME_PRIZE_COLLECTION:
      return {
        ...state,
        dataPrizeCollectionMini: actions.payload.data,
      };
    case MINIGAME_TAKE_PRIZE:
      return {
        ...state,
        dataTakePrizeMini: actions.payload.data,
      };
    case MINIGAME_RANKING:
      return {
        ...state,
        dataRankingMini: actions.payload.data,
      }
    case MINIGAME_GET_RULE:
      return {
        ...state,
        dataRule: actions.payload.data,
      }
   
    case SHOW_POPUP_EARNMORE:
      return {
        ...state,
        popupEarnMore: actions.data,
      };
    case SHOW_POPUP_PIECE:
      return {
        ...state,
        popupPiece: actions.data,
      };
    case SHOW_POPUP_CHANGE_COINS_SUCCESS:
      return {
        ...state,
        popupChangeCoinsSuccess: actions.data,
      };
    case SHOW_POPUP_GIVE_PIECE:
      return {
        ...state,
        popupGivePiece: actions.data,
      };
    case SHOW_POPUP_GIVE_PIECE_SUCCESS: 
      return {
        ...state,
        popupGivePieceSuccess: actions.data,
      }
    case SHOW_POPUP_MISSION: 
      return {
        ...state,
        popupMission: actions.data,
      }
    case SHOW_POPUP_PUZZLE:
      return {
        ...state,
        popupPuzzle: actions.data,
      }
    default:
      return state;
  }
};

export default reducerMiniGame;
